import { render, staticRenderFns } from "./perfectInfo.vue?vue&type=template&id=5ca8f7ec&scoped=true&"
import script from "./perfectInfo.vue?vue&type=script&lang=js&"
export * from "./perfectInfo.vue?vue&type=script&lang=js&"
import style0 from "./perfectInfo.vue?vue&type=style&index=0&id=5ca8f7ec&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca8f7ec",
  null
  
)

export default component.exports